import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ModelBadge')(({ badgeSize }) =>
  css({
    ml: 's',
    width: badgeSize,
  }),
);

themeStyles.addBaseStyles('Link')(({ last, color }) =>
  css({
    fontWeight: 'normal',
    fontFamily: 'bold',
    display: 'block',
    width: '100%',
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '18px',
    textDecoration: 'none',
    py: 'default',
    mx: 'default',
    color,
    borderBottom: '1px solid',
    borderBottomColor: last === 'true' ? 'transparent' : 'grey.3',
    // for activeClassName
    '&.active': {
      color: 'primary',
    },
    letterSpacing: '0.5px',
  }),
);

themeStyles.addBaseStyles('ShowOnlyInLandscape')(
  css({
    display: 'none',
    '@media (orientation: landscape)': {
      display: 'block',
    },
  }),
);

export default themeStyles;
